import { mapActions } from 'vuex';
import { sendPageViewAPI } from '@/store/modules/api/api';
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapActions('common', {
      setNavigationAction: 'setNavigation',
      setStartProjectPopAction: 'setStartProjectPop',
      setRecruitPopAction: 'setRecruitPop',
      setPdsPopAction: 'setPdsPop',
      setAwardsPopAction: 'setAwardsPop',
      setCulturePopAction: 'setCulturePop'
    }),
    showStartProject() {
      try {
        this.setStartProjectPopAction(true);
        sendPageViewAPI(`project`);
      } catch (err) {
        console.error(`showStartProject err : `, err);
      }
    },
    showRecruit() {
      try {
        this.setRecruitPopAction(true);
        sendPageViewAPI(`recruit`);
      } catch (err) {
        console.error(`showRecruit err : `, err);
      }
    },
    showPds() {
      this.setPdsPopAction(true);
    },
    showCulture() {
      this.setCulturePopAction(true);
    },
    hideAllPop() {
      this.setStartProjectPopAction(false);
      this.setRecruitPopAction(false);
      this.setPdsPopAction(false);
      this.setCulturePopAction(false);
    },
    imglink(url) {
      if (url !== '') {
        return require(`@/assets/images/${url}`);
      }
    },
    observeActive(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add('active');
      } else {
        entry.target.classList.remove('active');
      }
    },
    thisFn(fn) {
      this[fn]();
    }
  }
};
